import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading } from '@americanexpress/dls-react';

const HotelReviews = ({
  rating,
  ratingOutOf = 10,
  reviewCount,
  categories = [],
}) => {
  if (!rating && categories.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-align-items-center margin-2-t">
        <Heading level={3} variant="sans-xlarge-bold" className="margin-0">
          {rating}
        </Heading>
        <div className="margin-2-l">
          <p className="body-bold margin-0">
            out of
            {' '}
            {ratingOutOf}
          </p>
          {reviewCount && (
            <p className="body-2 margin-0">
              {reviewCount.toLocaleString()}
              {' '}
              reviews
            </p>
          )}
        </div>
      </div>

      {categories.length > 0 && (
        <div className="row margin-3-t">
          {categories.map((category) => (
            <div key={category.name} className="col-12 col-sm-6 col-md-4 margin-2-b">
              <div className="border-t pad-t">
                <div className="flex flex-justify-between">
                  <p className="body-bold margin-0">{category.name}</p>
                  <p className="body-bold margin-0">{category.rating}</p>
                </div>
                {category.description && (
                  <p className="body margin-1-t margin-0-b">{category.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <Button variant="secondary" className="margin-1-t">
        See All Reviews
      </Button>
    </>
  );
};

HotelReviews.propTypes = {
  rating: PropTypes.number,
  ratingOutOf: PropTypes.number,
  reviewCount: PropTypes.number,
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    description: PropTypes.string,
  })),
};

export default HotelReviews;
